import {schema} from 'normalizr'
import {API_ROOT_URL} from 'envs/_current/config'
import {createListTransform} from './utils/createListTransform'
import {createTransform} from './utils/createTransform'

export const timetableSchema = new schema.Entity(
    'timetables',
    {},
    {
        idAttribute: 'id',
    }
)
export const timetableDetailSchema = new schema.Entity(
    'timetable_details',
    {},
    {
        idAttribute: 'id',
    }
)

export const timetable_create_Api = {
    name: 'timetable_create_Api',
    backend: `Route::post('timetables/create', 'TimetableController@create');`,
    root: API_ROOT_URL,
    path: '/timetables/create',
    method: 'POST',
    schema: timetableSchema,
    transform: createTransform(timetableSchema, 'data'),
}

export const timetable_update_Api = {
    name: 'timetable_update_Api',
    backend: `Route::post('timetables/{id}/edit', 'TimetableController@update');`,
    root: API_ROOT_URL,
    path: '/timetables/:id/edit',
    method: 'POST',
    schema: timetableSchema,
    transform: createTransform(timetableSchema, 'data'),
}

export const timetable_delete_Api = {
    name: 'timetable_delete_Api',
    backend: `Route::post('timetables/{id}/delete', 'TimetableController@delete');`,
    root: API_ROOT_URL,
    path: '/timetables/:id/delete',
    method: 'POST',
    schema: timetableSchema,
    transform: createTransform(timetableSchema, 'data'),
}

export const timetable_gets_Api = {
    name: 'timetable_gets_Api',
    backend: `Route::get('timetables/gets', 'TimetableController@gets');`,
    root: API_ROOT_URL,
    path: '/timetables/gets',
    method: 'GET',
    paramsFields: ['owner_type', 'owner_id', 'group_id', 'keyword', 'status', 'from_time_open', 'to_time_open'],
    schema: timetableSchema,
    transform: createListTransform(timetableSchema),
}

export const timetable_getMilestonesByDepartment_Api = {
    name: 'timetable_getMilestonesByDepartment_Api',
    backend: `Route::get('timetables/department/{id}/milestones', 'TimetableController@getMilestonesByDepartment');`,
    root: API_ROOT_URL,
    path: '/timetables/department/:id/milestones',
    method: 'GET',
    paramsFields: [
        'keyword',
        'status',
        'with_milestone',
        'group_id',
        'to_time_open',
        'from_time_open',
    ],
    schema: timetableSchema,
    transform: createListTransform(timetableSchema),
}

export const timetable_getsByOrganization_Api = {
    name: 'timetable_getsByOrganization_Api',
    backend: `Route::get('timetables/organization/{id}/gets', 'TimetableController@getsByOrganization');`,
    root: API_ROOT_URL,
    path: '/timetables/organization/:id/gets',
    method: 'GET',
    paramsFields: [
        'keyword',
        'status',
        'course_id',
        'subject_id',
        'course_class_id',
        'group_id',
        'group_member_id',
        'to_time_open',
        'from_time_open',
    ],
    schema: timetableSchema,
    transform: createListTransform(timetableSchema),
}

export const timetable_getDetails_Api = {
    name: 'timetable_getDetails_Api',
    backend: `Route::get('timetables/details', 'TimetableController@getDetails');`,
    root: API_ROOT_URL,
    path: '/timetables/details',
    method: 'GET',
    paramsFields: [
        'owner_type',
        'owner_id',
        'group_id',
        'subject_id',
        'timetable_detail_id',
        'status',
        'from_time_open',
        'to_time_open',
    ],
    schema: timetableDetailSchema,
    transform: createListTransform(timetableDetailSchema),
}

/**
 * @deprecated dùng timetable_getDetails_Api (owner_type=organization) thay thế. Giữ tạm để tương thích ngược.
 */
export const timetable_getDetailsByOrganization_Api = {
    name: 'timetable_getDetailsByOrganization_Api',
    backend: `Route::get('timetables/organization/{id}/details', 'TimetableController@getDetailsByOrganization');`,
    root: API_ROOT_URL,
    path: '/timetables/organization/:id/details',
    method: 'GET',
    paramsFields: [
        'keyword',
        'group_id',
        'organization_timetable_detail_id',
    ],
    schema: timetableDetailSchema,
    transform: createListTransform(timetableDetailSchema),
}

/**
 * @deprecated dùng timetable_getDetails_Api (owner_type=course_class) thay thế. Giữ tạm để tương thích ngược.
 */
export const timetable_getDetailsByCourseClass_Api = {
    name: 'timetable_getDetailsByCourseClass_Api',
    backend: `Route::get('timetables/course-class/{id}/details', 'TimetableController@getDetailsByCourseClass');`,
    root: API_ROOT_URL,
    path: '/timetables/course-class/:id/details',
    method: 'GET',
    paramsFields: [
        'keyword',
        'subject_id',
        'course_class_timetable_detail_id',
    ],
    schema: timetableDetailSchema,
    transform: createListTransform(timetableDetailSchema),
}

export const timetable_getDetailsByMember_Api = {
    name: 'timetable_getDetailsByMember_Api',
    backend: `Route::get('timetables/member/{id}/gets', 'TimetableController@getDetailsByMember');`,
    root: API_ROOT_URL,
    path: '/timetables/member/:id/gets',
    method: 'GET',
    paramsFields: [
        'keyword',
        'group_id',
        'organization_timetable_detail_id',
        'month_number',
        'year_number',
        'from_time_open',
        'to_time_open',
    ],
    schema: timetableDetailSchema,
    transform: createListTransform(timetableDetailSchema),
}

export const timetable_getMilestonesByCourseClass_Api = {
    name: 'timetable_getMilestonesByCourseClass_Api',
    backend: `Route::get('timetables/course-class/{id}/milestones', 'TimetableController@getMilestonesByCourseClass');`,
    root: API_ROOT_URL,
    path: '/timetables/course-class/:id/milestones',
    method: 'GET',
    paramsFields: ['keyword', 'with_milestone', 'subject_id'],
    schema: timetableSchema,
    transform: createListTransform(timetableSchema),
}

export const timetable_getTeacherSubjectsOfCourseClass_Api = {
    name: 'timetable_getTeacherSubjectsOfCourseClass_Api',
    backend: `Route::get('timetables/course-class/{id}/teacher-subjects', 'TimetableController@getTeacherSubjectsOfCourseClass');`,
    root: API_ROOT_URL,
    path: '/timetables/course-class/:id/teacher-subjects',
    method: 'GET',
    paramsFields: ['keyword', 'with_milestone', 'subject_id'],
    schema: timetableSchema,
    transform: createListTransform(timetableSchema),
}

export const timetable_getsByClassesOwner_Api = {
    name: 'timetable_getsByClassesOwner_Api',
    backend: `Route::get('timetables/owner/{type}/{id}/gets', 'TimetableController@getsByClassesOwner');`,
    root: API_ROOT_URL,
    path: '/timetables/owner/:type/:id/gets',
    method: 'GET',
    paramsFields: [
        'keyword',
        'status',
        'course_id',
        'subject_id',
        'course_class_id',
        'to_time_open',
        'from_time_open',
    ],
    schema: timetableSchema,
    transform: createListTransform(timetableSchema),
}

export const timetable_getDetailsByStudent_Api = {
    name: 'timetable_getDetailsByStudent_Api',
    backend: `Route::get('timetables/student/{id}/gets', 'TimetableController@getDetailsByStudent');`,
    root: API_ROOT_URL,
    path: '/timetables/student/:id/gets',
    method: 'GET',
    paramsFields: ['keyword', 'course_class_id', 'subject_id', 'month_number', 'year_number'],
    schema: timetableDetailSchema,
    transform: createListTransform(timetableDetailSchema),
}

export const timetable_getDetailsByTeacher_Api = {
    name: 'timetable_getDetailsByTeacher_Api',
    backend: `Route::get('timetables/teacher/{id}/gets', 'TimetableController@getDetailsByTeacher');`,
    root: API_ROOT_URL,
    path: '/timetables/teacher/:id/gets',
    method: 'GET',
    paramsFields: ['keyword', 'course_class_id', 'subject_id', 'month_number', 'year_number'],
    schema: timetableDetailSchema,
    transform: createListTransform(timetableDetailSchema),
}
